import React from 'react';

const SvgSchemas = props => (
  <svg data-name="Layer 1" viewBox="0 0 24 24" {...props}>
    <path
      d="M20.59 3.38a.71.71 0 00-.92-.38l-5 2.13L9.63 3a.7.7 0 00-.55 0L3.84 5.23a.71.71 0 00-.43.65l-.06 14.45a.7.7 0 00.7.7.6.6 0 00.27-.03l5-2.07 5 2.08a.76.76 0 00.27.05A1 1 0 0015 21l5.27-2.17a.7.7 0 00.43-.65V3.66a.67.67 0 00-.11-.28zm-15.77 3l3.82-1.65v13l-3.87 1.6zm5.24 11.33V4.73l3.82 1.62.06 12.93zm9.18 0l-3.88 1.6.06-12.93 3.82-1.62z"
      fill="#989898"
    />
  </svg>
);

export default SvgSchemas;
